module.exports = __webpack_public_path__ + "static/media/sloss.aa4831ad.m4a";